export default __webpack_public_path__ + "static/media/site_banner_es.79eeb910.m4v";